export default "__VITE_ASSET__BYCvSjW3__"